<div class="autowcont allpads m-top-ii">
    <div class="basicrow f-reg f-black roboto-r">
        <div class="basicrow f-big">
            Confirmación de Recarga
        </div>
        <div class="dts-rcrg m-top-ii text-center">
            <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="basicrow">
                        <span class="roboto-b">N&uacute;mero de T&eacute;lefono</span><br />
                        <span class="f-big roboto-b">{{this.subscriber}}</span>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="basicrow l-pline-i">
                        <span class="roboto-b">Monto Pagado</span><br />
                        <span class="f-lsemi roboto-b f-red">{{this.total|currency}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow m-top-i">
            <div class="logline full"></div>
        </div>
        <div  class="basicrow m-top-i text-center">
            <div class="shortcont">
                <div id="printable">
                    <div class="green-confrm">
                        <i class="fa fa-check-circle checkconfrm" aria-hidden="true"></i>
                        <span class="roboto-b">&#161;Gracias por su pago&#33;</span><br />
                        se ha realizado exitosamente la recarga.
                    </div>
                    <div class="basicrow m-top">
                        <div class="logline full"></div>
                    </div>
                    <div class="basicrow text-center m-top-i">
                        Guarda o Imprime la siguiente informaci&oacute;n como evidencia de la transacci&oacute;n:
                    </div>
                    <div class="basicrow m-bott-ii m-top">
                        <div class="userinfo full nomtops">
                            <div class="basicrow">
                                <div class="redstat m-top">
                                    <div class="autorow roboto-r pull-left">
                                        N&uacute;mero de Transacci&oacute;n
                                    </div>
                                    <div class="autorow roboto-b pull-right">
                                        #{{this.idTransaction}}
                                    </div>
                                </div>
                                <div class="redstat m-top-ii">
                                    <div class="autorow roboto-r pull-left">
                                        N&uacute;mero de la Recarga
                                    </div>

                                    <div class="autorow roboto-b pull-right">
                                        {{this.idTransactionRecarga}}
                                    </div>
                                </div>
                                <div class="redstat m-top-ii">
                                    <div class="autorow roboto-r pull-left">
                                        Fecha y Hora
                                    </div>

                                    <div class="autorow roboto-b pull-right">
                                        {{this.allDate}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="basicrow m-top">
                    <div class="logline full"></div>
                </div>
                <div class="basicrow text-center m-top-i">
                    <a class="btns def-i red pull-right vcenter" (click)="this.printDiv3('printable');">
                        <span class="tabcell">
                            Imprimir
                        </span>
                    </a>
                    <a (click)="this.return()" class="btns def-i gray pull-left vcenter">
                        <span class="tabcell">
                            Cerrar
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>